// Ready translated locale messages
export const messages = {
  en: {
    title: 'Title',
    kpi: {
      refText: 'Reference last'
    },
    login: {
      reset: 'Reset password',
      back: 'Back to login',
      email_msg: 'Sending email ...',
      header: 'Login',
      forgotPassw: 'Forgot username or password?',
      email: 'Email',
      password: 'Password',
      email_sended: 'Email sended',
      new_password: 'New Password',
      rep_newpass: 'Repeat password'
    },
    message: {
      hello: 'Welcome to Kernel Vue.js App!'
    },
    validation: {
      default: 'Wrong value',
      input: {
        special_characters: 'Special characters are not allowed (E.g. # ? / %)',
        email: 'Please enter a valid email address',
        password_confirm: 'The confirmation doesn´t match'
      }
    },
    buttons: {
      help: 'Help',
      home: 'Home',
      profile: 'Profile',
      settings: 'Settings',
      users: 'Manage users',
      logout: 'Log out',
      gohome: 'Back to home',
      clearFields: 'Clear fields',
      save: 'Save',
      addNew: 'Add new'
    },
    labels: {
      language: 'Language',
      interface_settings: 'Interface settings',
      kbnav: 'Filters and buttons on tables',
      colorContrast: 'Color contrast',
      fontSize: 'Font size',
      knavHover: 'Show on mouse hover',
      knavNormal: 'Show always',
      normal: 'Normal',
      highContrast: 'High Contrast',
      big: 'Big',
      compact: 'Compact',
      loading: 'Loading...',
      firstName: 'First Name',
      lastName: 'Last Name',
      isActive: 'Is Active',
      typeUser: 'Type of user',
      title: 'Title',
      description: 'Description'
    },
    errors: {
      webmaster: 'If the error persists, please contact the website webmaster.',
      e301: {
        title: 'Moved Permanently',
        description: 'This and all future requests should be directed to a new url'
      },
      e400: {
        title: 'Bad Request',
        description: 'The server cannot or will not process the request due to an apparent client error, it could be a malformation of the URL'
      },
      e401: {
        title: 'Unauthorized',
        description: 'Authentication is required and has failed or has not yet been provided. '
      },
      e403: {
        title: 'Forbidden',
        description: 'The request was valid, but the server is refusing action. Your user might not have the necessary permissions for a resource, or may need an account of some sort.'
      },
      e404: {
        title: 'Not Found',
        description: 'The requested resource could not be found but may be available in the future. Subsequent requests by the client are permissible.'
      },
      e405: {
        title: 'Method Not Allowed',
        description: 'A request method is not supported for the requested resource.'
      },
      e429: {
        title: 'Too Many Requests',
        description: 'The user has sent too many requests in a given amount of time.'
      },
      e500: {
        title: 'Internal Server Error',
        description: 'Unexpected condition was encountered'
      },
      e501: {
        title: 'Not Implemented',
        description: 'The server either does not recognize the request method, or it lacks the ability to fulfil the request.'
      },
      e502: {
        title: 'Bad Gateway',
        description: 'The server was acting as a gateway or proxy and received an invalid response from the upstream server.'
      },
      e503: {
        title: 'Service Unavailable',
        description: 'The server is currently unavailable (because it is overloaded or down for maintenance).'
      },
      e504: {
        title: 'Gateway Timeout',
        description: 'The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.'
      }
    },
    design: {
      title: 'Style guide',
      typography: 'Typography',
      colors: 'Colors',
      forms: 'Form elements'
    },
    tables: {
      showColumn: 'Show column',
      hideColumn: 'Hide column'
    },
    users: {
      title: 'Users list',
      addUser: 'Add User',
      editUser: 'Edit User',
      saveUser: 'Save User',
      addUserOther: 'Add another user'
    }
  },
  es: {
    title: 'Título',
    kpi: {
      refText: 'Última referencia'
    },
    login: {
      reset: 'Recuperar contraseña',
      back: 'Regresar',
      email_msg: 'Enviando email ...',
      header: 'Login',
      forgotPassw: '¿Olvidaste tu usuario o contraseña?',
      email: 'Email',
      password: 'Contraseña',
      email_sended: 'Email enviado',
      new_password: 'Nueva contraseña',
      rep_newpass: 'Repetir contraseña'
    },
    message: {
      hello: 'Hola bienvenido a la template de Kernel'
    },
    validation: {
      default: 'Valor incorrecto',
      input: {
        special_characters: 'No acepta carácteres especiales (Ej. # ? / %)',
        email: 'Por favor introduce una contraseña válida',
        password_confirm: 'La confirmación no es igual a tu contraseña'
      }
    },
    buttons: {
      help: 'Ayuda',
      home: 'Inicio',
      profile: 'Perfil',
      settings: 'Preferencias',
      users: 'Gestión usuarios',
      logout: 'Salir',
      gohome: 'Regresar al inicio',
      clearFields: 'Borrar formulario',
      save: 'Guardar',
      addNew: 'Añadir nuevo'
    },
    labels: {
      language: 'Idioma',
      interface_settings: 'Ajustes de interfície',
      kbnav: 'Filtros y botones en tablas',
      colorContrast: 'Contraste de color',
      fontSize: 'Tamaño de la fuente',
      knavHover: 'Mostrar con el cursor del ratón',
      knavNormal: 'Mostrar siempre',
      normal: 'Normal',
      highContrast: 'Alto Contraste',
      big: 'Grande',
      compact: 'Compacto',
      loading: 'Cargando...',
      firstName: 'Nombre',
      lastName: 'Apellido',
      isActive: 'Activo',
      typeUser: 'Tipo de usuario',
      title: 'Título',
      description: 'Descripción'
    },
    errors: {
      webmaster: 'Si el error persiste, por favor contactar al administrador de sistemas.',
      e301: {
        title: 'Página movida permanentemente',
        description: 'Ésta y todas las peticiones futuras deberían ser dirigidas a una nueva URL.'
      },
      e400: {
        title: 'Bad Request',
        description: 'La solicitud contiene sintaxis errónea y no debería repetirse.'
      },
      e401: {
        title: 'Unauthorized',
        description: 'La autentificación ha fallado o aún no ha sido habilitada.'
      },
      e403: {
        title: 'Forbidden',
        description: 'No estás autorizado para entrar a esta página. La solicitud fue correcta, pero el servidor rehúsa responderla dado que el cliente no tiene los privilegios para hacerla.'
      },
      e404: {
        title: 'Página web no encontrada',
        description: 'Recurso no encontrado. El servidor web no encuentra la página o recurso solicitado.'
      },
      e405: {
        title: 'Method Not Allowed',
        description: 'Una petición fue hecha a una URI utilizando un método de solicitud no soportado por dicha URI.'
      },
      e429: {
        title: 'Too Many Requests',
        description: 'Hay muchas conexiones desde esta dirección de internet.'
      },
      e500: {
        title: 'Internal Server Error',
        description: 'Error inesperado.'
      },
      e501: {
        title: 'Not Implemented',
        description: 'El servidor no soporta alguna funcionalidad necesaria para responder a la solicitud del navegador.'
      },
      e502: {
        title: 'Bad Gateway',
        description: 'El servidor está actuando de proxy o gateway y ha recibido una respuesta inválida del otro servidor, por lo que no puede responder adecuadamente a la petición del navegador.'
      },
      e503: {
        title: 'Service Unavailable',
        description: 'El servidor no puede responder a la petición del navegador porque está congestionado o está realizando tareas de mantenimiento.'
      },
      e504: {
        title: 'Gateway Timeout',
        description: 'El servidor está actuando de proxy o gateway y no ha recibido a tiempo una respuesta del otro servidor, por lo que no puede responder adecuadamente a la petición del navegador.'
      }
    },
    design: {
      title: 'Guía de estilo',
      typography: 'Tipografía',
      colors: 'Colores',
      forms: 'Formularios'
    },
    tables: {
      showColumn: 'Mostrar columna',
      hideColumn: 'Esconder columna'
    },
    users: {
      title: 'Listado de usuarios',
      addUser: 'Añadir usuario',
      editUser: 'Editar usuario',
      saveUser: 'Guardar usuario',
      addUserOther: 'Añadir otro usuario'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/dictionary.js